<template>
  <v-ons-page class="white-background">
    <v-ons-toolbar>
      <div class="center">Menu</div>
    </v-ons-toolbar>

    <v-ons-list>
      <v-ons-list-item
        modifier="longdivider chevron"
        v-for="(item, $index) in pages"
        @click="push(item.page, item.filter)"
        :key="$index">
        <div class="center">{{ item.label }}</div>
      </v-ons-list-item>
    </v-ons-list>
  </v-ons-page>
</template>

<script>
import ContactCards from './ContactCards'
import CompanyHistory from './CompanyHistory'
import Legal from './Legal'
import Favorites from './Favorites'
import { appData } from '../data.js'

export default {
  name: 'main-menu',
  data () {
    return {
      pages: [
        {
          label: 'Find a Sales Rep',
          page: ContactCards,
          filter: 'IsSales'
        },
        {
          label: 'Company History',
          page: CompanyHistory,
        },
        {
          label: 'Company Directory',
          page: ContactCards,
          filter: 'IsCompany'
        },
        {
          label: 'My Favorites',
          page: Favorites,
        },
        {
          label: 'Legal',
          page: Legal
        }
      ]
    }
  },
  methods: {
    push(page, filter) {
      this.$emit('push-page', {
        extends: page,
        onsNavigatorProps: {
          employees: appData.state.employees.filter(e => e[filter]),
          sales: filter === 'IsSales'
        }
      });
    },
  },
  created() {

  }
}
</script>

<style scoped>
.header {
  text-align: center;
  margin-bottom: 20px;
}

img {
  max-width: 150px;
}

ons-list-title {
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue